var _path, _path2, _rect, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 64,
    viewBox: "0 0 54 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8096 4.45117H7.56191C4.49015 4.45117 2 7.02553 2 10.2012V56.2012C2 59.3768 4.49015 61.9512 7.56191 61.9512H29.8096C32.8813 61.9512 35.3715 59.3768 35.3715 56.2012V10.2012C35.3715 7.02553 32.8813 4.45117 29.8096 4.45117Z",
    stroke: "#407DBB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6836 50.4512H18.9753",
    stroke: "#407DBB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.6992,
    y: 1.61816,
    width: 28.3988,
    height: 23.3613,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6984 0H25.0984C23.3384 0 21.8984 1.44 21.8984 3.2V32L28.2984 25.6H50.6984C52.4584 25.6 53.8984 24.16 53.8984 22.4V3.2C53.8984 1.44 52.4584 0 50.6984 0ZM50.6984 22.4H26.9704L25.0984 24.272V3.2H50.6984V22.4ZM29.8984 11.2H33.0984V14.4H29.8984V11.2ZM42.6984 11.2H45.8984V14.4H42.6984V11.2ZM36.2984 11.2H39.4984V14.4H36.2984V11.2Z",
    fill: "#407DBB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.5e99b8e37733cd539db7f146216555c5.svg";
export { ForwardRef as ReactComponent };